import { Suspense } from 'react';
import { Spinner } from 'app/components/core/Spinner';
import { BuildInfoContainer } from 'app/components/features/BuildInfo';
import { NotificationHubContainer } from 'app/components/features/NotificationHub';
import { CreateNewProjectDialogLauncher } from 'app/components/features/CreateNewProjectDialog';
import { WarehouseLoadDialogLauncher } from 'app/components/features/WarehouseLoadDialog';
import { IntegrationUnconfiguredDialogContainer } from 'app/components/features/IntegrationUnconfiguredDialog';
import { AppErrorOverlayContainer } from './AppErrorOverlayContainer.js';
import { HealthcheckOverlayContainer } from './HealthcheckOverlayContainer.js';
import { SnowflakeDisconnectedOverlayContainer } from './SnowflakeDisconnectedOverlayContainer.js';
import { LicenseWarningOverlay } from './LicenseWarningOverlay.jsx';

export const AppOverlays = () => (
    <Suspense fallback={<Spinner />}>
        <AppErrorOverlayContainer />
        <BuildInfoContainer />
        <NotificationHubContainer />
        <HealthcheckOverlayContainer />
        <CreateNewProjectDialogLauncher />
        <IntegrationUnconfiguredDialogContainer />
        <LicenseWarningOverlay />
        <SnowflakeDisconnectedOverlayContainer />
        <WarehouseLoadDialogLauncher />
    </Suspense>
);
